/** Maps API enum values (underscores) to i18n keys under *.values (spaces). */
export const mapApiEnumValueToTranslationKey = (value: string): string => value.replace(/_/g, ' ');
